module.exports = __webpack_public_path__ + "img/error-img.e837cfa9.png";